import * as Yup from "yup";
import swal from "sweetalert";
import { useFormik } from "formik";
import { login, setToken, getToken, decodeToken } from '../../api/users';

import { useContext, useState } from "react";
import { UserContext } from "../../context/UserContext";
import { useTranslation } from "react-i18next";
// import i18n from "i18nextConf";
import Loading from "../../components/Loading";
import bgLogin from '../../assets/log.png'

const validationSchema = Yup.object().shape({
  username: Yup.string().required('user_required'),
  password: Yup.string().required('password_required'),
});

const Login = () => {

  const {ready} = useTranslation();
  const [loading, setLoading] = useState(false);

  const {setUserInfo} = useContext(UserContext)

  const handleSubmit = async (payload: any): Promise<void> => {
    setLoading(true);
    login(payload)
    .then( (resp:any) => {

      const { data } = resp;
      const token = resp.data.access;
      setToken(data);

      swal('',"user_valid",'success')
      .then(() => {
        setLoading(false);
        const decode = decodeToken();
        setUserInfo({
          token,
          exp:decode.exp
        });
        // history.push('/admin/dashboard');

      })
    })
    .catch( err => {
      setLoading(false);
      const status = err?.response?.status;
      if (!status) {
        swal("Error de conexión", "No se pudo conectar al servidor. Intente más tarde.", "error");
      } else if (status === 401) {
        swal("", "Usuario o contraseña inválidos", "error");
      } else {
        swal("Error", `Error inesperado (${status})`, "error");
      }
    });
  };

  const initialValues = {
    username: "",
    password: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  if( getToken() ){
    // return <Redirect to="/admin/dashboard" />
  }

  if(!ready){
    return <Loading />
  }

  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-12 col-md-9">
            <div className="card o-hidden border-0 shadow-lg my-5">
              <div className="card-body p-0">
                <div className="row">
                  <div className="col-lg-6 d-none d-lg-block"
                  style={{
                    backgroundImage: `url(${bgLogin})`,
                    backgroundSize: "cover",
                    backgroundPosition: 'center center',
                    backgroundAttachment: 'scroll',
                    backgroundRepeat: 'no-repeat'
                  }}></div>
                  <div className="col-lg-6">
                    <div className="p-5">
                      <div className="text-center">
                        <img
                          src="/img/logo.png"
                          alt=""
                          style={{
                            width: "200px",
                            height: "auto",
                            display: "block",
                            margin: "12px auto",
                          }}
                        />
                      </div>
                      <form className="user" onSubmit={formik.handleSubmit}>
                        <div className="form-group">
                          <input
                            type="username"
                            placeholder={'username'}
                            name="username"
                            className={`form-control form-control-user ${
                              formik.errors.username && formik.touched.username
                                ? "is-invalid"
                                : ""
                            }`}
                            value={formik.values.username}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                            {formik.errors.username && formik.touched.username ? (
                                <div className="invalid-feedback">{formik.errors.username}</div>
                            ) : null}
                        </div>
                        <div className="form-group">
                          <input
                            type="password"
                            name="password"
                            className={`form-control form-control-user ${
                                formik.errors.password && formik.touched.password
                                  ? "is-invalid"
                                  : ""
                              }`}
                              value={formik.values.password}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              placeholder={'password'}
                          />
                            {formik.errors.password && formik.touched.password ? (
                                <div className="invalid-feedback">{formik.errors.password}</div>
                            ) : null}
                        </div>
                        <button className="btn btn-primary btn-user btn-block"
                        type="submit"
                        disabled={loading}>
                          {"ingresar"}
                        </button>
                      </form>
                      <hr />
                      <div className="text-center">
                        {/* <Link to="/password-forget" className="small">
                          {'olvido_clave'}
                        </Link> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
